import { render } from "./BMyTicketRemarksDisp.vue?vue&type=template&id=953315e6&scoped=true"
import script from "./BMyTicketRemarksDisp.vue?vue&type=script&lang=js"
export * from "./BMyTicketRemarksDisp.vue?vue&type=script&lang=js"

import "./BMyTicketRemarksDisp.vue?vue&type=style&index=0&id=953315e6&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-953315e6"

export default script